module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/watch-1-c7cba1b66edeb3a5ee61a9d96d88230d.svg";